import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@Utils';

import { ManualUploadList, PageWrapper, Select } from '@Components';
import { Options } from '@Models';
import { SelectOptions } from '../../Components/Select/select';

interface Clients {
  name: string;
  date: string;
}

interface ManualUploadProps {
  clients: Clients[];
  refetch: (name: string) => void;
  isFetching: boolean;
  retailers: Options[];
  selectedRetailer?: Options;
  setRetailer: (options: Options) => void;
}

const ManualUpload = ({
  clients,
  refetch,
  isFetching,
  retailers,
  selectedRetailer,
  setRetailer,
}: ManualUploadProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleRetail = (e: SelectOptions): void => {
    if (e) setRetailer(e);
  };

  useEffect(() => {
    setLoading(isFetching);
  }, [isFetching]);

  return (
    <div className={cn(loading && 'pointer-events-none animate-pulse', 'h-full w-full')}>
      <PageWrapper title={t('ManualUpload.Title')}>
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
          <div className="flex md:flex-row mx-6 my-4 items-center flex-col">
            <span className="font-bold text-xl justify-start text-gray-700">
              {`${t('ManualUpload.All')} (${clients?.length ?? 0})`}
            </span>
            <div className="ml-auto flex gap-2 w-[50%] lg:flex-row flex-col">
              <div className="w-full text-[15px]">
                <Select
                  placeholder={t('User.Select')}
                  defaultValue={selectedRetailer}
                  options={retailers}
                  onChange={handleRetail}
                />
              </div>
            </div>
          </div>
          {selectedRetailer && (
            <ManualUploadList configures={clients ?? []} retailer={selectedRetailer.value} refetch={refetch} />
          )}
        </div>
      </PageWrapper>
    </div>
  );
};

export default ManualUpload;
